import React from "react";
import ReactDOM from "react-dom";
import Main from "./Main";
import "./style.css";
import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: 'G-633KZ62TS3'
}

TagManager.initialize(tagManagerArgs)

ReactDOM.render(
  <Main/>, 
  document.getElementById("root")
);